import { useEffect, useState } from 'react';

import type { GetAllCuratorTaskRecordsQuery } from 'generated/curator-task.generated';
import { useGetAllCuratorTaskRecordsLazyQuery } from 'generated/curator-task.generated';
import type { TaskDateFilter, TaskOwnership } from 'generated/types';

export function useGetCuratorTasks(
  date_filter: TaskDateFilter,
  ownership: TaskOwnership
) {
  const [tasks, setTasks] = useState<
    GetAllCuratorTaskRecordsQuery['getAllCuratorTaskRecords']['data']
  >([]);
  const [getCuratorTasks, { loading }] = useGetAllCuratorTaskRecordsLazyQuery();

  useEffect(() => {
    async function fetchCuratorTasks() {
      const response = await getCuratorTasks({
        variables: {
          input: {
            filters: {
              ownership,
              date_filter,
            },
          },
        },
      });
      const curatorTasks = response.data?.getAllCuratorTaskRecords.data;
      setTasks(curatorTasks);
    }
    fetchCuratorTasks();
  }, [date_filter, getCuratorTasks, ownership]);

  return {
    tasks,
    loading,
  };
}
